import './App.css';
import './ui/Button'
import Modal from "./ui/Modal";
import Button from "./ui/Button";
import Row from "./ui/Row";

function App() {
  return (
    <div className="App">
        <Modal title="Modal Title">
            <p>Вы уверены?</p>
            <Row>
                <Button title="OK" classname="btn btn-success"/>
                <Button title="Close Modal" classname="btn btn-danger"/>
            </Row>
        </Modal>
    </div>
  );
}

export default App;
